declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

const PIXEL_ID = '2134630104036378'

let initialized = false

export function initPixel() {
  if (initialized) return
  initialized = true

  // Set up fbq queue immediately so tracking calls don't fail
  const f = window as any
  if (f.fbq) return

  const n: any = (f.fbq = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as unknown[][]

  window.fbq('init', PIXEL_ID)

  // Defer loading the actual SDK until browser is idle
  const loadSDK = () => {
    const t = document.createElement('script') as HTMLScriptElement
    t.async = true
    t.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const s = document.getElementsByTagName('script')[0]
    s?.parentNode?.insertBefore(t, s)
  }

  if ('requestIdleCallback' in window) {
    ;(window as any).requestIdleCallback(loadSDK)
  } else {
    setTimeout(loadSDK, 2000)
  }
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Cadenas Rotas',
      content_type: 'product',
      value: 8.49,
      currency: 'USD',
    })
  }
}
